// The video access a viewer has at this moment (Clerk publicMetadata.videoAccess;
// claude/VIDEOS.md). Permanent access is a year per collection (masterclassVideosUntil,
// workshopVideosUntil). Limited Access (a free place: the Custom deal, a Press Pass; fullstack
// claude/PRESS.md) adds masterclassTemporary or workshopTemporary {year, until: ISO instant}:
// while it lasts it unlocks only that event's speakers' videos, never a collection; after it,
// nothing. A permanent year (a purchase) covers the whole collection, superseding the grant.
// A copy of fullstack shared/videos/getVideoAccessNow.js; LIMITED copies fullstack
// shared/events/limitedAccess.json (built from the program on the fullstack's dev start: copy it
// again when it changes; design principle 13a's accepted exception).

const LIMITED = {
  "masterclass-2026": {
    accessUntil: "2026-11-16T12:00:00.000Z",
    videos: ["ea074acfc2", "a5f4839b29", "484934e3ab", "00ed2509a7", "fd8dcbb737"],
  },
  "workshop-2026": {
    accessUntil: "2026-12-02T12:00:00.000Z",
    videos: ["5739199dd4", "1a30fb02e6", "978e99b5dd", "e9274b2c6c"],
  },
};

export const TEMPORARY_FIELDS = {
  masterclass: "masterclassTemporary", workshop: "workshopTemporary",
};

// a grant ends at its event's date (earlier grants follow a change of date), else its own
export function getTemporaryUntil(temporary, kind = "masterclass") {
  const event = LIMITED[`${kind}-${Number(temporary?.year)}`];
  return Date.parse(event?.accessUntil || temporary?.until);
}

export function getIsTemporaryValid(temporary, now = Date.now(), kind = "masterclass") {
  return Number(temporary?.year) > 0 && getTemporaryUntil(temporary, kind) > now;
}

// the permanent years alone: a temporary grant never counts as a collection
export function getVideoAccessNow(videoAccess) {
  const permanent = {...videoAccess};
  for (const field of Object.values(TEMPORARY_FIELDS)) delete permanent[field];
  return permanent;
}

// the Vimeo hashes the temporary grants unlock now ([] once they have expired, or without one)
export function getTemporaryVideos(videoAccess, now = Date.now()) {
  const kinds = Object.keys(TEMPORARY_FIELDS);
  const valid = kinds.filter((kind) =>
    getIsTemporaryValid(videoAccess?.[TEMPORARY_FIELDS[kind]], now, kind));
  return valid.flatMap((kind) => {
    const year = Number(videoAccess[TEMPORARY_FIELDS[kind]].year);
    return LIMITED[`${kind}-${year}`]?.videos || [];
  });
}
